<template>
  
    <div>
      <!-- Toggle Control Button -->
      <div
        @click="showLayerControl = !showLayerControl"
        style="width: 25px; height: 25px; border-radius: 5px; cursor: pointer;"
        class="d-flex justify-content-end align-items-center w-100"
      >
        <img
          src="/img/413047030_679066331074301_507646546545438464_n.jpg"
          style="width: 30px; border-radius: 15px;"
        />
      </div>

      <!-- Layer List -->
      <div v-if="showLayerControl">
        <h5 class="text-center" style="margin: 0 0 5px;">Χάρτες</h5>
        <div
          v-for="layer in arcgisLayers"
          :key="layer.name"
          @click="toggleLayer(layer)"
          :style="{
            cursor: 'pointer',
            padding: '5px',
            border: activeLayer === layer ? '1px solid #007bff' : '1px solid transparent'
          }"
        >
          <input
            type="checkbox"
            :checked="activeLayer === layer"
            style="margin-right: 10px;"
            readonly
          />
          {{ layer.category }} - {{ layer.name }}
        </div>
        <p class="mt-2">© από Ψηφιακό Χάρτη Κτηματολογίου</p>
      </div>
    </div>
 
</template>

<script>
import L from "leaflet";

import * as esri from 'esri-leaflet';

export default {
  name: 'ArcgisLayerControl',
  props: {
    mapObject: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showLayerControl: false,
      activeLayer: null,
      arcgisLayers: [
      {
        category: "Δασικός Χάρτης",
        name: "DX_KYROSH",
        url: "https://services-eu1.arcgis.com/40tFGWzosjaLJpmn/ArcGIS/rest/services/DASIKA_KYROSH_P_gdb/FeatureServer/0",
        visible: false,
        drawingInfo:{"renderer":{"type":"simple","symbol":{"type":"esriSFS","style":"esriSFSSolid","color":[76,129,205,191],"outline":{"type":"esriSLS","style":"esriSLSSolid","color":[0,0,0,255],"width":0.75}}},"transparency":0,"labelingInfo":null}
      },
      {
        category: "Δασικός Χάρτης",
        name: "DX_ANARTHSH",
        url: "https://services-eu1.arcgis.com/40tFGWzosjaLJpmn/ArcGIS/rest/services/DASIKA_ANARTHSH_P_gdb/FeatureServer/0",
        visible: false,
        drawingInfo:{"renderer":{"type":"simple","symbol":{"type":"esriSFS","style":"esriSFSSolid","color":[76,129,205,191],"outline":{"type":"esriSLS","style":"esriSLSSolid","color":[0,0,0,255],"width":0.75}}},"transparency":0,"labelingInfo":null}
      },
      {
        category: "Κτηματολόγιο",
        name: "PROKATARKTIKA",
        url: "https://services-eu1.arcgis.com/40tFGWzosjaLJpmn/ArcGIS/rest/services/GEOTEMAXIA_PROKATARKTIKA_ON_gdb/FeatureServer/0",
        visible: false,
        drawingInfo:{"renderer":{"type":"simple","symbol":{"type":"esriSFS","style":"esriSFSSolid","color":[76,129,205,191],"outline":{"type":"esriSLS","style":"esriSLSSolid","color":[0,0,0,255],"width":0.75}}},"transparency":0,"labelingInfo":null}

      },
      {
        category: "Κτηματολόγιο",
        name: "PROANARTHSH",
        url: "https://services-eu1.arcgis.com/40tFGWzosjaLJpmn/ArcGIS/rest/services/GEOTEMAXIA_PROANARTHSH_ON_gdb/FeatureServer/0",
        visible: false,
        drawingInfo:{"renderer":{"type":"simple","symbol":{"type":"esriSFS","style":"esriSFSSolid","color":[76,129,205,191],"outline":{"type":"esriSLS","style":"esriSLSSolid","color":[0,0,0,255],"width":0.75}}},"transparency":0,"labelingInfo":null}

      },
      {
        category: "Κτηματολόγιο",
        name: "ANARTHSH",
        url: "https://services-eu1.arcgis.com/40tFGWzosjaLJpmn/ArcGIS/rest/services/GEOTEMAXIA_ANARTHSH_ON_gdb/FeatureServer/0",
        visible: false,
        drawingInfo:{"renderer":{"type":"simple","symbol":{"type":"esriSFS","style":"esriSFSSolid","color":[76,129,205,191],"outline":{"type":"esriSLS","style":"esriSLSSolid","color":[0,0,0,255],"width":0.75}}},"transparency":0,"labelingInfo":null}

      },
      {
        category: "Κτηματολόγιο",
        name: "LEITOURGOUN",
        url: "https://services-eu1.arcgis.com/40tFGWzosjaLJpmn/ArcGIS/rest/services/GEOTEMAXIA_LEITOURGOUN_ON_gdb/FeatureServer/0",
        visible: false,
        drawingInfo:{"renderer":{"type":"simple","symbol":{"type":"esriSFS","style":"esriSFSSolid","color":[76,129,205,191],"outline":{"type":"esriSLS","style":"esriSLSSolid","color":[0,0,0,255],"width":0.75}}},"transparency":0,"labelingInfo":null}

      },
      {
        category: "Κτηματολόγιο",
        name: "APOKLEISTIKES",
        url: "https://services-eu1.arcgis.com/40tFGWzosjaLJpmn/ArcGIS/rest/services/GEOTEMAXIA_APOKLEISTIKES_ON_gdb/FeatureServer/0",
        visible: false,
        drawingInfo:{"renderer":{"type":"simple","symbol":{"type":"esriSFS","style":"esriSFSSolid","color":[76,129,205,191],"outline":{"type":"esriSLS","style":"esriSLSSolid","color":[0,0,0,255],"width":0.75}}},"transparency":0,"labelingInfo":null}

      },
      {
        category: "Κτηματολόγιο",
        name: "DOULEIES",
        url: "https://services-eu1.arcgis.com/40tFGWzosjaLJpmn/ArcGIS/rest/services/GEOTEMAXIA_DOULEIES_ON_gdb/FeatureServer/0",
        visible: false,
        drawingInfo:{"renderer":{"type":"simple","symbol":{"type":"esriSFS","style":"esriSFSSolid","color":[76,129,205,191],"outline":{"type":"esriSLS","style":"esriSLSSolid","color":[0,0,0,255],"width":0.75}}},"transparency":0,"labelingInfo":null}

      },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
        const map = this.mapObject;
    
        this.arcgisLayers.forEach((layer) => {
            // Extract drawingInfo for styles
            console.log(layer)
            const renderer = layer.drawingInfo.renderer;
            const symbol = renderer.symbol;

            // Helper function to convert ArcGIS RGBA to CSS-compatible rgba()
            const rgbaToCss = (rgba) =>
            `rgba(${rgba[0]}, ${rgba[1]}, ${rgba[2]}, ${rgba[3] / 255})`;

            // Create the layer with custom styles
            layer.leafletLayer = esri.featureLayer({
            url: layer.url,
            style: function () {
                return {
                // Fill color and opacity
                fillColor: rgbaToCss(symbol.color),
                fillOpacity: symbol.color[3] / 255,
                // Outline color and weight
                color: rgbaToCss(symbol.outline.color),
                weight: symbol.outline.width,
                };
            },
            });

            // ✅ Add click event to the layer
            layer.leafletLayer.on('click', (event) => {
            const feature = event.layer.feature;
            const latlng = event.latlng; // This is where the mouse clicked on the map
            console.log("Feature clicked:", feature);
            // You can emit event, open popup, or update UI here
            // Example: open popup
            // Build HTML content from feature.properties
            let popupContent = "<b>Feature Properties:</b><br/><table class='table table-bordered table-sm table-responsive'  style='max-height: 350px; min-width: 345px;'>";

            for (const key in feature.properties) {
                popupContent += `
                <tr>
                    <td><strong>${key}</strong></td>
                    <td>${feature.properties[key]}</td>
                </tr>
                `;
            }

            popupContent += "</table>";

            L.popup()
            .setLatLng(latlng) // 👈 Set popup at click position
            .setContent(popupContent)
            .openOn(map);
            });

            // Add visible layers to the map initially
            if (layer.visible) {
            layer.leafletLayer.addTo(map);
            }
        });

    });

  },
  methods: {
    toggleLayer(layer) {
      const map = this.mapObject;

      if (this.activeLayer) {
        this.activeLayer.leafletLayer.removeFrom(map);
      }

      if (this.activeLayer === layer) {
        this.activeLayer = null;
        return;
      }

      layer.leafletLayer.addTo(map);
      this.activeLayer = layer;
    }
  }
};
</script>
